import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'routes.Error.title',
    defaultMessage: 'Error',
    description: '备注: 页面title'
  },
  code: {
    id: 'routes.Error.code',
    defaultMessage: 'code',
    description: 'code的文案'
  },
})
